import { useAppSelector } from '../../../../common/hooks/redux';
import { useWhoAmIQuery } from '../../infrastructure/api/auth.api';

/**
 * Session bootstrap: GET /v1/auth/whoami with HttpOnly cookie.
 * whoAmI matchers in authSlice set status / identity — no manual mapping here.
 */
export function useCookieSessionBootstrap(): {
  isBootstrapping: boolean;
} {
  const status = useAppSelector(state => state.auth.status);
  const { isUninitialized, isLoading, isFetching } = useWhoAmIQuery(undefined, {
    refetchOnMountOrArgChange: true,
    refetchOnFocus: true,
  });

  const isBootstrapping =
    status === 'unknown' && (isUninitialized || isLoading || isFetching);

  return { isBootstrapping };
}
